import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import classNames from 'classnames';
import { ApiTableView } from 'components/ApiTable/components/ApiTableView';
import { reloadTableDataInViewport } from 'components/ApiTable/model/commands/reloadTableDataInViewport';
import type { ApiTablePageHook } from 'components/ApiTablePage/useApiTablePage';
import { DeviceView } from 'components/DeviceView/DeviceView';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import { memo } from 'react';
import { type FC, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { useCloudSecurityTreeModal } from './useCloudSecurityTreeModal';
import { useTableSecurityModal } from './useTableSecurityModal';

type Props = {
  borderless?: boolean;
  model: ApiTablePageHook;
  rowHeight?: number;
  tableClassName?: string;
  tableViewClassName?: string;
};

const BareApiTablePageView: FC<Props> = (props) => {
  const snapshotId = useSnapshotId();
  const securityModal = useTableSecurityModal();
  const cloudSecurityTreeModal = useCloudSecurityTreeModal();
  const reloadParentTable = useStableCallback(() => {
    props.model.apiTableModel.dispatch(reloadTableDataInViewport);
  });
  return (
    <Fragment key={props.model.apiTableModel.endpoint.id}>
      <Helmet title={props.model.apiTableModel.endpoint.title} />
      {props.model.sharedViewLoading ? (
        <LoaderAndText />
      ) : (
        <ApiTableView
          borderless={props.borderless}
          className={classNames(
            'flex-1',
            props.model.tableDeviceView.tableClassName,
            props.tableClassName,
          )}
          model={props.model.apiTableModel}
          rowHeight={props.rowHeight}
          tableClassName={props.tableViewClassName}
        />
      )}
      <DeviceView
        deviceView={props.model.tableDeviceView.deviceView}
        disableDetach
        onReloadParentTable={reloadParentTable}
        panelClassName='relative z-popup'
        snapshotId={snapshotId}
      />
      {securityModal}
      {cloudSecurityTreeModal}
    </Fragment>
  );
};

export const ApiTablePageView = memo(BareApiTablePageView);
